import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFieldList = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 30 30",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M28.333 25a1.667 1.667 0 010 3.333H11.667a1.667 1.667 0 110-3.333h16.666zm0-11.667a1.667 1.667 0 010 3.334H11.667a1.667 1.667 0 010-3.334h16.666zm0-11.666a1.667 1.667 0 010 3.333H11.667a1.667 1.667 0 110-3.333h16.666zM0 1.667C0 .747.746 0 1.667 0H5c.92 0 1.667.746 1.667 1.667V5c0 .92-.747 1.667-1.667 1.667H1.667C.747 6.667 0 5.92 0 5V1.667zm0 11.666c0-.92.746-1.666 1.667-1.666H5c.92 0 1.667.746 1.667 1.666v3.334c0 .92-.747 1.666-1.667 1.666H1.667c-.92 0-1.667-.746-1.667-1.666v-3.334zM0 25c0-.92.746-1.667 1.667-1.667H5c.92 0 1.667.747 1.667 1.667v3.333C6.667 29.253 5.92 30 5 30H1.667C.747 30 0 29.254 0 28.333V25z",
		fillRule: "nonzero"
	})
});
export default SvgFieldList;
